import React, { useState } from "react";

export default function ClassicalLab() {
  const [bits, setBits] = useState([0, 0]);
  const [output, setOutput] = useState("");

  const toggleBit = (i) => {
    const newBits = [...bits];
    newBits[i] = newBits[i] ? 0 : 1;
    setBits(newBits);
  };

  const applyGate = (gate) => {
    let result = [...bits];
    let newOutput = null;

    switch (gate) {
      case "NOT A":
        result[0] = bits[0] ? 0 : 1;
        break;
      case "NOT B":
        result[1] = bits[1] ? 0 : 1;
        break;
      case "AND":
        newOutput = bits[0] & bits[1];
        break;
      case "OR":
        newOutput = bits[0] | bits[1];
        break;
      case "XOR":
        newOutput = bits[0] ^ bits[1];
        break;
      case "NAND":
        newOutput = 1 - (bits[0] & bits[1]); // NAND = NOT(AND)
        break;
     
      default:
        break;
    }

    setBits(result);
    if (newOutput !== null) setOutput(newOutput);
  };

  return (
    <div className="classical-lab">
      <div className="gate-panel top">
        <button onClick={() => applyGate("NOT A")}>NOT A</button>
        <button onClick={() => applyGate("NOT B")}>NOT B</button>
        <button onClick={() => applyGate("AND")}>AND</button>
        <button onClick={() => applyGate("OR")}>OR</button>
        <button onClick={() => applyGate("XOR")}>XOR</button>
        <button onClick={() => applyGate("NAND")}>NAND</button>
      </div>

      <div className="classical-layout">
        <div className="bit-panel">
          {bits.map((b, i) => (
            <div key={i} className="bit-box" onClick={() => toggleBit(i)}>
              {b}
            </div>
          ))}
        </div>

        <div className="output-box big">{output}</div>
      </div>
    </div>
  );
}
